import { API_BASE_URL } from '../config';

/**
 * Formats an image URL to ensure it's a complete URL
 * If the URL is relative (starts with '/'), it prepends the API base URL
 * If the URL is already complete (starts with 'http'), it returns it as is
 * If the URL is not provided, it returns the default placeholder
 */
export const formatImageUrl = (imageUrl?: string, placeholder: string = '/placeholder-speaker.svg'): string => {
  console.log('formatImageUrl input:', imageUrl);
  
  if (!imageUrl) {
    console.log('No image URL, returning placeholder:', placeholder);
    return placeholder;
  }
  
  // If the URL is already absolute (starts with http:// or https://), return as is
  if (imageUrl.startsWith('http://') || imageUrl.startsWith('https://')) {
    console.log('URL is already absolute, returning as is:', imageUrl);
    return imageUrl;
  }
  
  // If it's a relative URL (starts with /)
  if (imageUrl.startsWith('/')) {
    const fullUrl = `${API_BASE_URL}${imageUrl}`;
    console.log('Relative URL with leading slash, returning:', fullUrl);
    return fullUrl;
  }
  
  // Handle other cases (perhaps local paths without leading slash)
  const fullUrl = `${API_BASE_URL}/${imageUrl}`;
  console.log('Other case, returning:', fullUrl);
  return fullUrl;
};
